<script>
export default {
  data() {
    return {
      useAutoFilters: !this.$fischer.app.isFite() && !this.$fischer.app.isUpat(),
    };
  },
  computed: {
    autoFilters() {
      if (this.filters.length === 0 && this.useAutoFilters) {
        const isDiy = this.$fischer.user.isDiy();
        const isProfi = this.$fischer.user.isProfi();
        if (isDiy && !isProfi) {
          return [
            {
              associatedFieldName: 'Profi / DIY_A',
              name: 'DIY~~~!Profi',
              displayField: 'Profi / DIY (DIY)',
              fakeValue: 'DIY',
            },
          ];
        }
        if (!isDiy && isProfi) {
          return [
            {
              associatedFieldName: 'Profi / DIY_A',
              name: 'Profi~~~!DIY',
              displayField: 'Profi / DIY (Profi)',
              fakeValue: 'Profi',
            },
          ];
        }
      }

      return null;
    },
  },
  methods: {
    applyChanges(...changes) {
      let filters = this.useAutoFilters
        ? (this.autoFilters || []).map((filter) => ({
            ...filter,
            name: filter.fakeValue || filter.name,
          }))
        : this.filters;

      changes.forEach(({ element, value }) => {
        // remove old filter if already active
        const oldFiltersLength = filters.length;
        filters = filters.filter(
          (oldFacet) => oldFacet.associatedFieldName !== element.associatedFieldName,
        );
        if (oldFiltersLength !== filters.length) {
          this.disableAutoFilters();
        }

        // add to active filters
        if (value) {
          filters.push(element);
          this.disableAutoFilters();
        }
      });

      if (!this.useAutoFilters) {
        // sort for better cache hits and consistent urls
        // there should not be too many filters, so performance overhead for localeCompare should not matter
        filters.sort((first, second) =>
          first.associatedFieldName.localeCompare(second.associatedFieldName),
        );

        this.filters = filters;
      }
    },

    enableAutoFilters() {
      if (!this.$fischer.app.isFite() && !this.$fischer.app.isUpat()) {
        this.useAutoFilters = true;
      }
    },
    disableAutoFilters() {
      this.useAutoFilters = false;
    },
  },
};
</script>
